import React from 'react';

function Index(props) {
  return (
    <div
      className={`custom_container_page ${props?.className}`}
      style={props?.style}
    >
      <div className="custom_container_body">{props?.children}</div>
    </div>
  );
}

export default Index;
